// Model Loader control

page.three.control.models.load = function(){
    log.webgl("MODELS: LOAD");
    if(page.three.v.models.loaded) return false;
    page.three.v.models.loader.loading++;
    page.three.modelLoader.load(
        page.three.model.banga.path,
        function(gltf){
            log.webgl("MODEL: Loaded (banga)", 2);
            page.three.model.banga.mesh = gltf.scene.children[0];
            page.three.f.models.loadedMore();
        },
        function(xhr){},
        function(error){console.log( 'An error happened:\n' + error );}
    );

    page.three.v.models.loader.loading++;
    page.three.modelLoader.load(
        page.three.model.bangaLand.path,
        function(gltf){
            log.webgl("MODEL: Loaded (bangaLand)", 2);
            page.three.model.bangaLand.mesh = gltf.scene.children[0];
            page.three.f.models.loadedMore();
        },

        function(xhr){},
        function(error){console.log( 'An error happened:\n' + error );}
    );

    /* page.three.v.models.loader.loading++;
    page.three.modelLoader.load(
        page.three.model.zeme.path,
        function(gltf){
            
            page.three.model.zeme.mesh = gltf.scene.children[0];
            page.three.f.models.loadedMore();
        },
        function(xhr){},
        function(error){console.log( 'An error happened:\n' + error );}
    ); */



    page.three.v.models.loader.loading++;
    page.three.modelLoader.load(
        page.three.model.medis.path,
        function(gltf){
            log.webgl("MODEL: Loaded (medis)", 2);
            page.three.model.medis.mesh = gltf.scene.children[0];
            page.three.f.models.loadedMore();
        },
        function(xhr){},
        function(error){console.log( 'An error happened:\n' + error );}
    );

    page.three.v.models.loader.loading++;
    page.three.texture.godrays.tex = page.three.loader.load(page.three.texture.godrays.path, function(){
        log.webgl("TEXTURE: Loaded (godRays)", 2);
        page.three.f.models.loadedMore();
    });

    page.three.v.models.loader.loading++;
    page.three.texture.ball.tex = page.three.loader.load(page.three.texture.ball.path, function(){
        log.webgl("TEXTURE: Loaded (ball)", 2);
        page.three.f.models.loadedMore();
    });
}

page.three.f.models.loadedMore = function(){
    var v = page.three.v.models.loader;
    v.loaded++;
    v.progress = v.loaded / (v.loading + 1);
    page.checklist.slides.progress = v.progress;
    //page.control.preloader.progress(v.progress, 1000);
    //console.log(v.loaded, v.loading, v.progress);

    if(v.loaded == v.loading){
        log.webgl("MODELS: LOADED");
        page.three.f.models.init();
        page.quality = 2;
        page.quality = 3;
    }
}

page.three.f.models.init = function(){
    log.webgl("MODELS: INIT");
    if(page.three.v.models.loaded) return false;
    var wgl = page.three;

    wgl.godRays = new THREE.ShaderPass(THREE.GodRayShader);
    wgl.clouds = new THREE.ShaderPass(THREE.CloudsShader);
    wgl.pTanMat = new THREE.ShaderMaterial(THREE.pTangentShader);
    wgl.wlMat = new THREE.ShaderMaterial(THREE.bModelShader);
    wgl.lMat = new THREE.ShaderMaterial(THREE.landShader);
    wgl.tMat = new THREE.ShaderMaterial(THREE.treeShader);
    
    var vId = new Float32Array( wgl.model.banga.mesh.geometry.attributes.position.count );
    var myId = new Float32Array( wgl.model.banga.mesh.geometry.attributes.position.count );
    for(var i=0; i<vId.length; i++){
        vId[i] = (i%116)/116 + Math.floor(i / 116);
        myId[i] = i * 0.00001;
    }
    wgl.model.banga.mesh.geometry.setAttribute( 'vId', new THREE.BufferAttribute( vId, 1 ) );
    wgl.model.banga.mesh.geometry.setAttribute( 'myId', new THREE.BufferAttribute( myId, 1 ) );
    wgl.banga = new THREE.Points(wgl.model.banga.mesh.geometry, wgl.pTanMat);
    wgl.banga.renderOrder = 10;

    wgl.bangaLand = new THREE.Mesh(wgl.model.bangaLand.mesh.geometry, wgl.wlMat);
    wgl.bangaLand.renderOrder = 5;

    page.three.model.zeme.mesh = new THREE.PlaneBufferGeometry(1,1,50,30);
    wgl.lMat.side = THREE.BackSide;

    wgl.land = new THREE.Mesh(wgl.model.zeme.mesh, wgl.lMat); // nuimtas .geometry
    wgl.land.renderOrder = 1;

    var tyId = new Float32Array( wgl.model.medis.mesh.geometry.attributes.position.count );
    for(i=0; i<tyId.length; i++){
        tyId[i] = i * 0.0001;
    }
    wgl.model.medis.mesh.geometry.setAttribute( 'tyId', new THREE.BufferAttribute( tyId, 1 ) );
    wgl.tree = new THREE.Points(wgl.model.medis.mesh.geometry, wgl.tMat);
    wgl.tree.renderOrder = 7;
    


    wgl.composer.addPass(wgl.clouds);
    wgl.composer.addPass(wgl.godRays);
    wgl.scene.add(wgl.banga);
    wgl.scene.add(wgl.bangaLand);
    wgl.scene.add(wgl.land);
    wgl.scene.add(wgl.tree);

    wgl.banga.scale.set(3,2,2);
    wgl.banga.position.y = -1;
    wgl.banga.position.x = -2;

    wgl.bangaLand.scale.set(3,2,2);
    wgl.bangaLand.position.y = -1;//-1
    wgl.bangaLand.position.x = -2;

    wgl.land.scale.set(3,2,2);
    wgl.land.position.y = -1;

    let scl = 0.3;
    wgl.tree.scale.set(scl, scl, scl);
    wgl.tree.position.set(0.3,-1, 1.55);
    wgl.tree.rotation.set(0,-1.75,0);

    wgl.godRays.uniforms["texture"].value = wgl.texture.godrays.tex;
    wgl.godRays.uniforms.uColor.value = new THREE.Color(0.317, 0.576, 0.678);
    wgl.godRays.uniforms.opacity.value = 0;

    wgl.pTanMat.uniforms["uAlpha"].value = 0; // 0.12
    wgl.pTanMat.uniforms["uTex"].value = wgl.texture.ball.tex;

    wgl.wlMat.uniforms.uColor.value = new THREE.Color(0.105, 0.356, 0.392);
    wgl.wlMat.uniforms.uColor2.value = new THREE.Color(0.129, 0.313, 0.419);
    wgl.wlMat.uniforms.uAlpha.value = 0;

    wgl.lMat.uniforms.uColor.value = new THREE.Color(0.062, 0.745, 0.462);
    wgl.lMat.uniforms.uColor2.value = new THREE.Color(0.074, 0.662, 0.454);
    wgl.lMat.uniforms.uAlpha.value = 0;

    wgl.tMat.uniforms["uTex"].value = wgl.texture.lapas.tex;
    wgl.tMat.uniforms.uAlpha.value = 0;

    wgl.clouds.enabled = false;
    wgl.godRays.enabled = false;
    wgl.banga.visible = false;
    wgl.bangaLand.visible = false;
    wgl.land.visible = false;
    wgl.tree.visible = false;
    //page.control.preloader.progress(1, 1000);

    //page.list.home.loadRest();
    //setTimeout(function(){
        page.checklist.slides.progress = 1;
        page.three.v.models.loaded = true;
    //}, 5000);
}